var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({attrs:{"color":_vm.colorValue,"outlined":_vm.isOutlined,"width":_vm.fullWidth ? '100%' : _vm.$props.width}},'v-btn',Object.assign({}, _vm.$props, _vm.$attrs),false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }